import { useTranslation } from 'react-i18next'

import { OptionButton } from '@reveni-io/reveni-ui'

import { dashboardViewTypes } from '../constants'
import * as Styles from './styles'

const ViewTypeSelector = ({ viewType, onChangeViewType, show }) => {
  const { t } = useTranslation()

  if (!show) {
    return null
  }

  return (
    <Styles.Container>
      <OptionButton
        name={t('Transacciones')}
        isSelected={viewType === dashboardViewTypes.returns}
        onClick={() => onChangeViewType(dashboardViewTypes.returns)}
        showSelectedCheck={false}
      />
      <OptionButton
        name={t('Envíos')}
        isSelected={viewType === dashboardViewTypes.shipments}
        onClick={() => onChangeViewType(dashboardViewTypes.shipments)}
        showSelectedCheck={false}
      />
    </Styles.Container>
  )
}

export default ViewTypeSelector
